import { ChartType } from "enums/report";
import { FileDto } from "./common";
import { PartnerDto } from "./partner";
import { UserDto } from "./user";

export type AoaSheet = (string | number)[];

// USE FOR SERVER
export interface Axis {
  value: string;
  color: string;
}

export enum YValue {
  PERCENT = "%",
  PRICE = "$",
}

export enum YAxisID {
  Y = "y",
  Y1 = "y1",
}

export enum FieldType {
  BAR = "bar",
  LINE = "line",
}

// USE FOR CLIENT
export interface AxisMapped extends Axis {
  hide?: boolean;
  active?: boolean;
  highlight?: boolean;
  unit?: string;

  // show y value
  yValue?: YValue | undefined;

  // multi axis
  yAxisID?: YAxisID;

  // change x axis
  isXAxis?: boolean;

  // change field group stacked
  isFieldGroup?: boolean;

  // stacked bar line
  fieldType?: FieldType;
}

export interface ReportSheet<A = Axis> {
  data: AoaSheet[];
  yAxis: A[];
  xAxis: A[];
  chartType?: ChartType;
  commentary?: string;
}

export interface ReportDataDto<A = Axis> {
  [key: string]: ReportSheet<A>;
}

export interface BaseReportDto<A = Axis> {
  name: string;
  data: ReportDataDto<A>;
  emails: string[];
  attachments: FileDto[];
}

export interface ReportDto<A = Axis> extends BaseReportDto<A> {
  _id: string;
  partners: PartnerDto[];
  createdBy: string | UserDto;
  createdAt: Date;
  updatedAt: Date;
}

export interface SubmitReportDto extends BaseReportDto {
  partners?: string[];
}
